import { createFileRoute } from '@tanstack/react-router';
import NewPermisionGroupPage from 'src/Administration/NewPermisionGroupPage/NewPermisionGroupPage';

export const Route = createFileRoute('/systemadmin/_layout/groups/new')({
  component: NewPermisionGroupPage,
});
